<template>   
    <v-layout column="" fill-height="" id="#app" v-if="show" >  
        <MglMap 
            :style="size"   
            :accessToken="accessToken" 
            :center="malawi"
            :zoom="zoom"
            :mapStyle="mapStyle"
            @zoom="onZoom"
            @resize="onResize"
            @load="onMapLoaded"
            :attributionControl="false">

            <!-- //TOOLBAR -->
            <div class="pt-2 pr-8" justify-center > 
                <v-card class=" mx-5" :tile="false" color="white">
                    <v-layout justify-center="" align-center="">
                        <v-avatar
                            size="15"
                            :color="selectedDistrict.color" > 
                        </v-avatar>
                        <div class="pa-1 text-center">{{selectedDistrict.name}}</div>
                    </v-layout>
                </v-card> 
            </div>
            <!-- <MglAttributionControl /> -->
            <MglFullscreenControl/>
            <MglNavigationControl  position="top-right"/>
            
            <!-- //DISTRICTS -->
            <DIV v-for="(district, index) in districtsGeoJson" :key="index">
                
                <MglGeojsonLayer
                    @click="onSelectDistrict(district)"
                    type="fill"
                    :sourceId="district.id"
                    :layerId="district.id"
                    :source="district.source" 
                    :layer="district.layer">  
                </MglGeojsonLayer>  
                
                
            </DIV>

            <DIV v-for="(district, index) in districtsGeoJson" :key="10000+index"> 
                <MglGeojsonLayer 
                    type="symbol"
                    :sourceId="district.id2"
                    :layerId="district.id2"
                    :source="district.source" 
                    :layer="district.layer2">  
                </MglGeojsonLayer>  
            </DIV>

            <!-- <DIV v-for="(district, index) in districtsGeoJson" :key="index">
                
            </DIV> -->

            <!-- //CONSTITUENCY -->
            <!-- <DIV v-for="(constitueency, index) in constituenciesGeoJson" :key="index">
                <MglGeojsonLayer
                    @click="onSelectDistrict(district)"
                    type="fill"
                    :sourceId="constitueency.id"
                    :layerId="constitueency.id"
                    :source="constitueency.source" 
                    :layer="constitueency.layer">  
                </MglGeojsonLayer> 
            </DIV> -->

        </MglMap>  
        <not-page-spinner 
            :notShow="true" 
            :not="not"
            v-if="!mapLoaded"/> 
    </v-layout>
</template>

<script>  
import Mapbox from "mapbox-gl";
import {  
    MglMap, 
    MglAttributionControl,
    MglNavigationControl, 
    MglGeolocateControl,
    MglFullscreenControl,
    MglScaleControl,
    MglPopup,
    MglMarker,
    MglGeojsonLayer 
} from "vue-mapbox"; 
let ACCESS_TOKEN = "pk.eyJ1IjoicmVnaXNqZWFybWJlcmEiLCJhIjoiY2p1d2FscG9yMDJuYjRkcG8yc2xoNjc3YiJ9.A7halTxXC0lVxg5geUkLWQ"
let MAP_STYLE = "mapbox://styles/regisjearmbera/ckarnrysc1lk31iqhvpa3tkyl" 


export default {
    props:[
        'not',
        'resultsType',
        'mp_height',
        'mp_width',
        'mp_center',
        'mp_points',
        'mp_zoom'
    ],
    components: {
        MglMap,
        MglAttributionControl,
        MglNavigationControl,
        MglGeolocateControl,
        MglFullscreenControl,
        MglScaleControl,
        MglPopup,
        MglMarker,
        MglGeojsonLayer
    },
    data(){
        return{  
            show:true,
            visible:true,
            accessToken: ACCESS_TOKEN,  
            mapStyle: MAP_STYLE,  
            zoom:5.5,
            currentZoom:null,
            mapLoaded:false,

            newMap:{}, 
            malawi:[34.3015,-13.2543],
            lilongwe:[33.7741,-13.9626],
            selectedDistrict:{
                name:"MALAWI",
                color:'primary'
            }, 
        } 
    },
    mounted(){  
     
    },
    created(){  
         
    },
    computed:{ 
        size(){
            let loaded = this.mapLoaded
            let h = this.mp_height?this.mp_height:"300px"
            if (loaded) {
                
            }else{
                h = "0px"
            }

            
            let w = this.mp_width?this.mp_width:"100%"
            return " height:"+h+"; width:"+w+"; "
        },
        results(){
                return type=>{
                    return this.$store.getters.getResults(type)
                }
            },
        resultsDetails(){
                return type=>{
                    return this.$store.getters.getResultsDetails(type)
                }
            },
        JOINED_results(){
                let resultsType = this.resultsType
                let results = this.results(resultsType)  
                let resultsDetails = this.resultsDetails(resultsType) 
                let JOINED = this.not.JOIN_RESULTS(results,resultsDetails) 
                 
                return JOINED
            },
        malawiGeoJson(){
            let mlw = this.$store.getters.getMalawiGeoJson
            let mm = {
                'type': 'geojson',
                'data':{
                    "features":[ mlw[1] ],
                    "type": "FeatureCollection"
                    }, 
                } 
            return mm
        },
        districtsGeoJson(){
            let currentZoom = this.currentZoom
            let mlw = this.$store.getters.getDistrictsGeoJson
            let geoJsons = [] 
            let features = mlw?mlw.features:null 
            if (features) {
                features.forEach(ft => {
                    //let district_name = ft.properties.NAME_2?ft.properties.NAME_2:'NULL'
                    let district_name = ft.properties.District?ft.properties.District:'NULL'
                    let candidate = this.getDistrictCandidate(district_name)
                    let color = "#000"
                    let opacity = 0.8
                    let shortText = true
                    let numberOftext = 2
                    let textSize = 13
    
                    if (candidate) {
                        let votes = candidate.votes
                        if (votes===0) {
                            color = "#006180"
                        } else {
                            color = candidate.party_color
                        } 
                    }
                    if (this.not.TEXT_UP(district_name)==="LAKE MALWI") {
                        color = "#1b3138"
                    }
                    // console.log(this.not.TEXT_UP(district_name));
                    
                    if (currentZoom) {
                        if (currentZoom>6) {
                            shortText = false
                        } else {
                            shortText = true
                        }
                    }
                    geoJsons.push(this.not.CALCULATE_GEO(ft,district_name,color,opacity,shortText,numberOftext,textSize)) 
                });  
            }
            return geoJsons
        },
        constituenciesGeoJson(){
            let mlw = this.$store.getters.getConstituenciesGeoJson
            let geoJsons = [] 
            let features = mlw?mlw.features:null
            console.log(features,"1111111111");
            if (features) {
                features.forEach(ft => {
                    let constituency_name = ft.properties.Constituency?ft.properties.Constituency:'Null'
                    // let candidate = this.getConstituencyCandidate(constituency_name)
                    let color = "#000"
                    // if (candidate) {
                    //     color = candidate.party_color
                    // }
                    geoJsons.push(this.not.CALCULATE_GEO(ft,constituency_name,color)) 
                });  
            } 
            return geoJsons
        }
    },
    methods:{  
        onMapLoaded(data){
            this.mapLoaded = data.map._loaded
            this.zoom = 6.5
            this.currentZoom = 6.5
            setTimeout(() => {
                this.zoom = 4 
                setTimeout(() => {
                    this.zoom = 5.5 
                }, 5000);

            }, 3000);
            console.log(data.map._loaded,"..>>>");
            
        },
        onResize(data){
            //console.log(data,"Resize........"); 
        },
        onZoom(data){
            let zoom = data.map.getZoom()
            this.currentZoom = zoom 
        },
        onSelectDistrict(district){
            let district_name = district.id
            this.selectedDistrict.color = district.color
            this.selectedDistrict.name = this.not.TEXT_UP(district_name)
            this.$emit("onDistrict",district) 
        },
        getDistrictCandidate(name){
            //get district
            let allResults = this.JOINED_results
            let district = this.$store.getters.getDistrictByName(name)
            if(!name){return null}
            if(!district){return null}
            if(!allResults){return null}

            //get candidate by this district
            let code = district.code 
            let res = this.not.CALCULATE_CANDIDATES_RESULTS_BY_LOCATION(allResults,this.resultsType,"districts",code)
            if(res){
                let candidates = res.sort(this.not.dynamicSort('votes')) 
                return candidates[0]  
            }
            return null
        },
        getConstituencyCandidate(name){
            //get district
            let allResults = this.JOINED_results
            let constitueency = this.$store.getters.getConstituencyByName(name)
            if(!name){return null}
            if(!constitueency){return null}
            if(!allResults){return null}

            //get candidate by this district
            let code = constitueency.code 
            let res = this.not.CALCULATE_CANDIDATES_RESULTS_BY_LOCATION(allResults,this.resultsType,"constituencies",code)
            if(res){
                let candidates = res.sort(this.not.dynamicSort('votes')) 
                return candidates[0]  
            }
            return null
        }

    },
    watch:{
        size (v){
            this.show = false
            setTimeout(() => {
                this.show = true
            }, 100);
            
        }
       
    } 
}
</script> 

